




































import { Component, Vue, Prop } from 'vue-property-decorator';

@Component({})
export default class BaseInput extends Vue {
  @Prop({ type: String, required: true }) private type!: string;
  @Prop({ type: [String, Number], required: true }) private value!: string | number;
  @Prop({ type: String, required: false, default: '' }) private name!: string;
  @Prop({ type: String, required: false, default: '' }) private placeholder!: string;
  @Prop({ type: String, required: false, default: '' }) private autocomplete!: string;
  @Prop({ type: Boolean, required: false, default: false }) private focus!: boolean;
  @Prop({ type: Boolean, required: false, default: false }) private autofocus!: boolean;
  /* tslint:disable-next-line */
  @Prop({ type: Object, required: false, default: () => {} }) private validation!: object;
  @Prop({ type: Array, required: false, default: () => [] }) private validations!: [object];

  private setFocus(field: string): void {
    if (this.name === field) {
      (this.$refs[this.name] as HTMLElement).focus();
    }
  }

  private mounted(): void {
    if (this.focus) {
      (this.$refs[this.name] as HTMLElement).focus();
    }
  }
}
